import React, { useState } from 'react'
import getFoodChartOptions from '../../../utils/charts/foodChart'
import ChartModule from './ChartModule'
import TabPanel from '../../layout/TabPanel'
import FoodTable from '../Tables/FoodTable'
import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material'

function a11yProps (index) {
  return {
    id: `food-metric__tab-${index}`,
    'aria-controls': `food-metric__tab-${index}`
  }
}

export default function FoodChart (props) {
  const [selectedFoodTab, setSelectedFoodTab] = useState(0)

  const renderChartPanel = () => {
    return (
      <Card className='chart-card' sx={{ mb: 8 }}>
        <CardContent sx={{ pt: 0 }}>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'end', m: 0 }}>
            <Typography variant='h6' color='#7f7f7f'> Food </Typography>
            <Tabs
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              value={selectedFoodTab}
              onChange={(_e, val) => setSelectedFoodTab(val)}
              aria-label='Profile tabs'
            >
              <Tab data-testid='food__charts-tab' label='Graph' {...a11yProps(0)} />
              <Tab data-testid='food__table-tab' label='Table' {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={selectedFoodTab} index={0} noPadding>
            <ChartModule
              hideHeader
              hideBorder
              showChartActions
              dashboardViewStore={props.dashboardViewStore}
              memberObj={props.memberObj}
              metricType='food'
              getChartOptions={getFoodChartOptions}
              showMemberAlerts
              handleAlertClick={props.handleAlertClick} // eslint-disable-line react/jsx-handler-names
            />
          </TabPanel>
          <TabPanel value={selectedFoodTab} index={1} noPadding>
            <FoodTable
              hideHeader
              hideBorder
              dashboardViewStore={props.dashboardViewStore}
              memberObj={props.memberObj}
            />
          </TabPanel>
        </CardContent>
      </Card>

    )
  }

  return renderChartPanel()
}
